jQuery(function ($) {
  //---- Post caraousel ----------------------------------------------------------------
  if ($('.post-slider').length) {
    const splide = new Splide('.post-slider', {
      type: 'slide',
      perPage: 3,
      perMove: 3,
      // focus: 'center',     // Keep center alignment if you like
      autoplay: false,
      interval: 8000,
      pagination: false,
      padding: 0,
      gap: '2.5rem',
      breakpoints: {
        768: { perPage: 1, perMove: 1 },
      },
    });

    const counter = document.querySelector('.splide-counter');

    splide.on('mounted move', function () {
      const totalSlides = splide.length;
      const perPage = splide.options.perPage;
      const totalPages = Math.ceil(totalSlides / perPage);

      const currentPage = Math.floor(splide.index / perPage) + 1;

      if (counter) counter.textContent = `${currentPage} van ${totalPages}`;

      var $list = $('.splide__list');
      var $slides = $('.splide__slide');

      // Remove Splide’s auto-added role=presentation on <ul>
      $list.removeAttr('role');

      // Fix roles for each slide
      $slides.each(function (index) {
        $(this)
          .attr('role', 'listitem');
      });
    });

    splide.mount();
  }

  //---- Photo Gallery caraousel ----------------------------------------------------------------
  if ($('.gallery-slider').length) {
    $('.gallery-slider').each(function (index, elem) {
      const $slider = $(elem);
      // Set aria-label using id or index for uniqueness
      const id = $slider.attr('id') || index;
      $slider.attr('aria-label', 'Photo gallery carousel-' + id);

      // Use this DOM element as the selector for Splide
      const splide = new Splide(elem, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        autoplay: false,
        interval: 8000,
        pagination: false,
        padding: 0,
        gap: '2.5rem',
        breakpoints: {
          1311: {}
        }
      });

      splide.on('mounted move', function () {
        // Only affect this Splide instance's list and slides
        const $list = $slider.find('.splide__list');
        const $slides = $slider.find('.splide__slide');

        $list.removeAttr('role');
        $slides.attr('role', 'listitem');
      });

      splide.mount();
    });
  }

  //---- Photo Gallery Auto caraousel ----------------------------------------------------------------

  if ($('.gallery-auto-slider').length) {

    $('.gallery-auto-slider').each(function (index, elem) {
      const $carousel = $(elem); // This is a jQuery object for this slider

      // Set aria-label with unique id
      const id = $carousel.attr('id') || index;
      $carousel.attr('aria-label', 'Gallery carousel-' + id);

      // Initialize Splide on this specific carousel
      const galleryAuto = new Splide(elem, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pagination: false,
        padding: 0,
        gap: '2.5rem',
      });

      // Counter gets the FIRST .splide-counter inside this carousel
      const counter = $carousel.find('.splide-counter')[0];

      galleryAuto.on('mounted move', function () {
        const totalSlides = galleryAuto.length;
        const perPage = galleryAuto.options.perPage;
        const totalPages = Math.ceil(totalSlides / perPage);
        const currentPage = Math.floor(galleryAuto.index / perPage) + 1;

        // Update the counter only inside this carousel
        if (counter) counter.textContent = `${currentPage} van ${totalPages}`;

        var $list = $carousel.find('.splide__list');
        var $slides = $carousel.find('.splide__slide');

        $list.removeAttr('role');
        $slides.attr('role', 'listitem');
      });

      galleryAuto.mount();

      // Pause button within this gallery
      const pauseBtn = $carousel.find('.pause-gallery')[0];
      if (pauseBtn) {
        const iconPause = pauseBtn.querySelector('.icon.pause');
        const iconPlay = pauseBtn.querySelector('.icon.play');
        const label = pauseBtn.querySelector('span');

        iconPause.style.display = 'inline-block';
        iconPlay.style.display = 'none';

        pauseBtn.addEventListener('click', function () {
          if (iconPause.style.display !== 'none') {
            galleryAuto.Components.Autoplay.pause();
            iconPause.style.display = 'none';
            iconPlay.style.display = 'inline-block';
            label.textContent = 'Afspelen';
          } else {
            galleryAuto.Components.Autoplay.play();
            iconPause.style.display = 'inline-block';
            iconPlay.style.display = 'none';
            label.textContent = 'Pauzeren';
          }
        });
      }
    });
  }

  //---- Inspiratiepunten caraousel ------------------------------------------------------------- //
  if ($('.inspiratiepunten-slider').length) {
    const splide = new Splide('.inspiratiepunten-slider', {
      perPage: 6,
      perMove: 6,
      autoplay: false,
      pagination: false,
      gap: '1rem',
      breakpoints: {
        1480: { perPage: 5, perMove: 5 },
        1280: { perPage: 4, perMove: 4 },
        1023: { perPage: 3, perMove: 3 },
        800: { perPage: 2, perMove: 2 },
        540: { perPage: 1, perMove: 1 },
        480: { perPage: 1, perMove: 1, pagination: true },
      },
    });

    const counter = document.querySelector('.splide-counter');

    function updateCounter() {
      const totalSlides = splide.length;
      const perPage = splide.options.perPage;
      const totalPages = Math.ceil(totalSlides / perPage);

      const currentPage = Math.floor(splide.index / perPage) + 1;

      if (counter) counter.textContent = `${currentPage} van ${totalPages}`;

      var $list = $('.splide__list');
      var $slides = $('.splide__slide');

      // Remove Splide’s auto-added role=presentation on <ul>
      $list.removeAttr('role');

      // Fix roles for each slide
      $slides.each(function (index) {
        $(this)
          .attr('role', 'listitem');
      });
    }

    splide.on('mounted move', function () {
      updateCounter();
    });

    splide.mount();

    window.addEventListener('resize', function () {
      updateCounter();
    });
  }

  //FOR TESTING ON PLAYGROUND
  if ($('.play-slider').length) {
    const mapSplide = new Splide('.play-slider', {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      grid: {
        dimensions: [[2, 2]],
        // rows: 2,
        // cols: 2,
        gap: {
          row: '1em',
          col: '1em'
        }
      },
      autoplay: false,
      interval: 8000,
      pagination: false,
      padding: 0,
      // extensions: { Grid: window.splide.Extensions.Grid }
    });

    const counter = document.querySelector('.splide-counter');

    mapSplide.on('mounted move', function () {
      const totalSlides = mapSplide.length;
      const perPage = mapSplide.options.perPage;
      const totalPages = Math.ceil(totalSlides / perPage);

      const currentPage = Math.floor(mapSplide.index / perPage) + 1;

      if (counter) counter.textContent = `${currentPage} van ${totalPages}`;

      var $list = $('.splide__list');
      var $slides = $('.splide__slide');

      // Remove Splide’s auto-added role=presentation on <ul>
      $list.removeAttr('role');

      // Fix roles for each slide
      $slides.each(function (index) {
        $(this)
          .attr('role', 'listitem');
      });
    });

    mapSplide.mount(window.splide.Extensions);

    console.log(window.splide.Extensions.Grid);
  }


});
